module.exports = __webpack_public_path__ + "img/MDT.a87adaf9.png";